import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { UPDATE_VENDOR_STATUS_V2, UPDATE_VENDOR_STATUS_V2_SUCCESS, UPDATE_VENDOR_STATUS_V2_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';
import cogoToast from 'cogo-toast';

function* updateVendorStatusV2({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/vendor/benefit-type/airport-transfer/${payload?.id}/status`,
      method: 'PUT',
      data: payload?.data,
      headers: {
        ...filteredHeaders,
      },
    });

    if (response.status === 200) {
      cogoToast.success(`${response?.data?.message}`);
      yield put({
        type: UPDATE_VENDOR_STATUS_V2_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message}`);
      yield put({
        type: UPDATE_VENDOR_STATUS_V2_ERROR,
        payload: response?.response?.data?.message,
      });
    }
  } catch (error) {
    yield put({ type: UPDATE_VENDOR_STATUS_V2_ERROR, payload: error });
  }
}

export function* watchUpdateVendorStatusV2() {
  yield takeEvery(UPDATE_VENDOR_STATUS_V2, updateVendorStatusV2);
}

function* updateVendorStatusV2Saga() {
  yield all([fork(watchUpdateVendorStatusV2)]);
}

export default updateVendorStatusV2Saga;
